import React from 'react'

// Dropdown sidebar: animasi buka/tutup, dan menutup sendiri begitu kursor
// meninggalkan kotaknya. Fase `closing` menahan elemen tetap terpasang selama
// animasi keluar (CLOSE_MS harus sama dengan durasi `dropdown-out` di CSS).
const CLOSE_MS = 140
export function useDropdown(leaveDelay = 220) {
  const [phase, setPhaseState] = React.useState('closed') // closed | open | closing
  const phaseRef = React.useRef('closed')
  const timer = React.useRef(null)
  const setPhase = (p) => { phaseRef.current = p; setPhaseState(p) }
  const clear = () => clearTimeout(timer.current)
  React.useEffect(() => clear, [])

  const show = () => { clear(); setPhase('open') }
  const hide = () => {
    clear()
    if (phaseRef.current !== 'open') return
    setPhase('closing')
    timer.current = setTimeout(() => setPhase('closed'), CLOSE_MS)
  }
  return {
    mounted: phase !== 'closed',
    open: phase === 'open',
    toggle: () => (phaseRef.current === 'open' ? hide() : show()),
    hide,
    // Dipasang di pembungkus yang memuat tombol DAN panelnya, jadi berpindah
    // dari tombol ke daftar tidak dihitung sebagai "keluar".
    hoverProps: {
      onMouseEnter: () => { clear(); if (phaseRef.current === 'closing') setPhase('open') },
      onMouseLeave: () => {
        clear()
        if (phaseRef.current === 'open') timer.current = setTimeout(hide, leaveDelay)
      },
    },
  }
}
